import { TabsList, TabsTrigger } from './TabComponent';
import VerticalAccordion from 'components/VerticalAccordion';
import { ChartsNavTabsProps } from 'interfaces/components/chartsNavTabs';

const ChartsNavTabs = ({
  chartData,
  downloadIndex,
  handleChartIndex,
  presentationMode,
  currentChartIndex
}: ChartsNavTabsProps) => {
  return (
    <TabsList
      className='flex flex-col items-start justify-start gap-2'
      data-orientation='vertical'
    >
      {chartData.map(item => (
        <VerticalAccordion
          key={item.title}
          title={item.title}
          isOpen={item.charts
            .map(chart => chart.id)
            .includes(currentChartIndex)}
          content={item.charts.map(chart => (
            <TabsTrigger
              id={`${chart.title}_tab`}
              key={String(chart.title + chart.id)}
              onClick={() => handleChartIndex(chart.id)}
              value={downloadIndex ? '0' : String(chart.id)}
              onKeyUp={e => e.preventDefault()}
              onKeyDown={e => e.preventDefault()}
              className='relative w-full h-9 px-4 text-left
                            rounded-lg whitespace-nowrap overflow-hidden
                            text-gray-700 dark:text-gray-400
                            data-[state=active]:text-black
                            data-[state=active]:dark:text-white
                            data-[state=active]:bg-gray-300
                            data-[state=active]:dark:bg-[#404040]
                            data-[state=active]:font-semibold'
            >
              <span className='absolute top-1.5 z-20'>{chart.title}</span>
              <span
                aria-hidden='true'
                className={`absolute inset-0 -translate-x-full
                                transition-transform ease-linear duration-[7s]
                                z-10 rounded-lg bg-[#E3F1E8]
                                ${
                                  presentationMode &&
                                  currentChartIndex === chart.id
                                    ? 'translate-x-0'
                                    : '!duration-[0s]'
                                }`}
              />
            </TabsTrigger>
          ))}
        />
      ))}
    </TabsList>
  );
};

export default ChartsNavTabs;
